import { Box, Typography } from '@mui/material';
import { Button } from '../../../../Components/MUIs';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
import { useDispatch } from 'react-redux';
import BottomSheet from '../../../../Components/Ui/BottomSheet';

export default function DeletePermitBottomSheet({ open, Delete1, title }) {
  const dispatch = useDispatch();

  return (
    <BottomSheet
      isHeaderChildren={true}
      headerText={''}
      headerChildren={
        <Typography
          sx={{ fontSize: '18px', fontWeight: 'bold', display: 'flex' }}
        >
          {title}
        </Typography>
      }
    >
      <Box sx={{ px: 1 }}>
        <Typography style={{ color: '#918A8A', paddingBottom: '0.5rem' }}>
          삭제 후 되돌릴 수 없습니다. 계속 진행하시겠습니까?
        </Typography>
      </Box>
      <Box
        p={1}
        bgcolor="#fff"
        sx={{
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          display: 'flex',
          gap: 8,
        }}
      >
        <Button
          name="취소"
          sx={{
            width: '100%',
            height: 36,
            borderRadius: '5px',
            backgroundColor: 'transparent',
            border: `1px solid #776D6D`,
            color: '#776D6D',
            boxShadow: 'none',
          }}
          onClick={() => {
            dispatch(BottomSheetActions.CloseBottomSheet());
          }}
        />
        <Button
          name="확인"
          sx={{
            width: '100%',
            height: 36,
            borderRadius: '5px',
            backgroundColor: '#57B84D',
            color: '#fff',
            boxShadow: 'none',
          }}
          onClick={() => {
            dispatch(BottomSheetActions.CloseBottomSheet());
            Delete1();
          }}
        />
      </Box>
    </BottomSheet>
  );
}
